// extracted by mini-css-extract-plugin
export default {"container":"styles_container__MkXEQ","content":"styles_content__a3H9c"};